import React, { useState } from 'react';
import {
  Box,
  Button,
  Collapse,
  Typography,
} from '@mui/material';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import { alpha } from '@mui/material/styles';
import colors from '../../assets/theme/colors';

const CollapsibleReviewGroup = ({
  label,
  count,
  reviewedCount = 0,
  destinationId = '',
  defaultOpen = true,
  titleWeight = 850,
  showReviewedCount = true,
  progressLabel = '',
  children,
}) => {
  const [open, setOpen] = useState(defaultOpen);

  React.useEffect(() => {
    setOpen(defaultOpen);
  }, [defaultOpen]);

  return (
    <Box
      id={destinationId || undefined}
      data-review-destination={label}
      sx={{
        border: `1px solid ${alpha(colors.semantic.ink, 0.12)}`,
        borderRadius: '14px',
        overflow: 'hidden',
        scrollMarginTop: 16,
      }}
    >
      <Button
        fullWidth
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
        sx={{
          px: 1.25,
          py: 0.85,
          justifyContent: 'flex-start',
          color: colors.semantic.ink,
          bgcolor: alpha(colors.semantic.sageMist, 0.5),
          textTransform: 'none',
        }}
      >
        <Typography sx={{ flex: 1, textAlign: 'left', fontSize: '0.94rem', fontWeight: titleWeight }}>
          {`${label} (${count})`}
        </Typography>
        {showReviewedCount ? (
          <Typography sx={{ mr: 0.5, fontSize: '0.74rem', color: colors.semantic.ink2 }}>
            {progressLabel || `${reviewedCount} reviewed`}
          </Typography>
        ) : null}
        <ExpandMoreRoundedIcon
          sx={{ fontSize: 20, transform: open ? 'rotate(180deg)' : 'none', transition: 'transform 180ms ease' }}
        />
      </Button>
      <Collapse in={open} timeout="auto">
        <Box sx={{ px: 1.15 }}>{children}</Box>
      </Collapse>
    </Box>
  );
};

export default CollapsibleReviewGroup;
